import { handleGTATracking } from "./gta";
import { handleFacebookPixelTracking } from "./facebook";
import { handleGTMTracking } from "./gtm";
import { handleTikTokPixelTracking } from "./tiktok";
import { handleGoogleAdsTracking } from "./google-ads";
import { handleSnackPixelTracking } from "./snack";
import { useFacebookPixel } from "./helpers/useFacebookPixel";
import { useTiktokPixel } from "./helpers/useTiktokPixel";

export async function createTrackingScripts(tracking, data, existingScripts, options = {}) {
  try {
    if (options.suppressTracking) {
      return;
    }

    const excludedEventNames = options.excludedEventNames || [];
    const trackingConfig = excludedEventNames.length
      ? Object.keys(tracking).reduce((result, key) => {
        const value = tracking[key];
        result[key] = Array.isArray(value)
          ? value.map((pixel) => pixel && Array.isArray(pixel.pixelEvents)
            ? { ...pixel, pixelEvents: pixel.pixelEvents.filter((event) => !excludedEventNames.includes(event.name)) }
            : pixel)
          : value;
        return result;
      }, {})
      : tracking;

    data = normalizeData(data)
    // [FW-4033] Pemanggil yang menunda injeksi pixel sudah memegang event key-nya sejak awal,
    // supaya key itu tetap ikut di payload order walau script-nya baru dimuat saat idle.
    const event_key = options.eventKey || generateTrackingUniqueKey();

    // GTA Tracking
    if (trackingConfig.GTA && trackingConfig.GTALabel) {
      await handleGTATracking(trackingConfig.GTA, trackingConfig.GTALabel, existingScripts);
    }

    // Facebook Pixel Tracking
    if (trackingConfig.FB && trackingConfig.FB.length) {
      useFacebookPixel();
      await handleFacebookPixelTracking(trackingConfig.FB, data, event_key, trackingConfig.globalConversionSetting);
    }

    // Google Tag Manager Tracking
    if (trackingConfig.GTM && trackingConfig.GTM.length) {
      await handleGTMTracking(trackingConfig.GTM, trackingConfig.globalConversionSetting, data.event_key);
    }

    // TikTok Pixel Tracking
    if (trackingConfig.tiktok && trackingConfig.tiktok.length) {
      useTiktokPixel();
      await handleTikTokPixelTracking(trackingConfig.tiktok, data, trackingConfig.globalConversionSetting);
    }

    // Google Ads Tracking
    if (trackingConfig.GA && trackingConfig.GA.length) {
      const conversion = data.transaction_id
        ? { transaction_id: data.transaction_id, order_number: data.order_number, value: data.value, currency: data.currency }
        : null;
      await handleGoogleAdsTracking(trackingConfig.GA, existingScripts, trackingConfig.globalConversionSetting, data.event_key, conversion);
    }

    // Snack Pixel Tracking
    if (trackingConfig.snack && trackingConfig.snack.length) {
      await handleSnackPixelTracking(trackingConfig.snack, data, trackingConfig.globalConversionSetting);
    }

    return {
      event_key
    };
  } catch (error) {
    console.error("Error in createTrackingScripts:", error);
  }
}

export function isArchivedBannedDeviceOrder(order = {}) {
  return order.isArchived === true && order.reasonArchived === 'bannedDevice';
}

function normalizeData(data) {
  if (data.event_time) {
    const dateObject = new Date(data.event_time);
    const unixTimestampMs = dateObject.getTime();
    const eventTimeSeconds = Math.floor(unixTimestampMs / 1000);

    data.event_time = eventTimeSeconds;
  }

  return data;
}

export function generateTrackingUniqueKey() {
  const unixTimestampMs = Date.now();
  const sixDigitRandomNumber = Math.floor(100000 + Math.random() * 900000);

  return `${unixTimestampMs}_${sixDigitRandomNumber}`;
}
